import { LoadingButton } from "@mui/lab";
import { Box, FormControl, Grid, Switch, FormControlLabel, Card, CardContent, Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import { PreventExit } from "components/PreventExit";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useNavigation } from "contexts/notificationsContext";
import { usePreventExit } from "hooks/usePreventExit";
import { useContext, useEffect, useState } from "react";
import { FormProvider, useForm, useFormState } from "react-hook-form";
import { useParams } from "react-router-dom";
import {
  getEmpresaById,
  getListarPorTipoMaterial,
  postEmpresasDadosCadastrais,
} from "services/modules/empresas";
import { IPostEmpresasDadosCadastrais } from "shared/interfaces/empresa";
import { DadosCadastraisForm } from "shared/interfaces/formEmpresa";

import { Save } from "@mui/icons-material";
import Typography from "@mui/material/Typography";
import { DataNotFound } from "components/DataNotFound";
import Select from "react-select";
import { FSelect } from "shared/interfaces/select";
import { fontsSizes } from "styles/theme";
import { CadastroEmpresaContext } from "contexts/cadastroEmpresaContext";
import { getBrasiliaTime } from "shared/helpers/cadastroEmpresas";
import { listarProjetistas, listarEmpresasConsulta } from "services/modules/aplicabilidades";

export const SEARCH_BAR_EMPRESA_ID = "search-bar-componente-anchor";

export type AplicabilidadesForm = {
  selectReferenciasBase: FSelect[];
  selectReferenciasAplicaveis: FSelect[];
  selectReferenciasProprias: FSelect[];
};

type FormTabelaPreco = {
  tipoSelecionados: Record<number, FSelect[]>;
};

export const AplicabilidadesForm = () => {
  const [tipoSelecionados, setTipoSelecionados] = useState<
    Record<number, FSelect[]>
  >(
    Array.from(
      {
        length: 5,
      },
      () => []
    )
  );

  const { selectedItems } = useContext(CadastroEmpresaContext);

  const {
    control,
    setValue,
    handleSubmit,
    reset,
    watch,
    setError,
    getValues,
    clearErrors,
    formState,
    ...methods
  } = useForm<DadosCadastraisForm>({
    mode: "onBlur",
  });

  const formTabPreco = useForm<FormTabelaPreco>();

  const formAplicabilidades = useForm<AplicabilidadesForm>({
    defaultValues: {
      selectReferenciasBase: [],
      selectReferenciasAplicaveis: [],
      selectReferenciasProprias: [],
    },
  });

  const formStateAplicabilidades = useFormState({
    control: formAplicabilidades.control,
  });

  const { errors, isDirty, dirtyFields } = useFormState({ control });
  const [hasChanges, setHasChanges] = useState(false);

  const { setDataUltimaAtualizacao } = useContext(CadastroEmpresaContext);
  const {
    isOpenModalUnsaved,
    handleIsOpenModalUnsaved,
    handleLinkNavigateBlocked,
    handleOnCloseModalUnsavedEdit,
    linkNavigateBlocked,
    isGoBack,
  } = usePreventExit((isDirty && Object.values(dirtyFields).length > 0) || hasChanges || formStateAplicabilidades.isDirty);

  const params = useParams();
  const { openNotification } = useNavigation();

  const [checkLiberacao, setCheckLiberacao] = useState(false);
  const [checkImportar, setCheckImportar] = useState(false);
  const [checkExportar, setCheckExportar] = useState(false);
  const [aplicabilidadeDisponivel, setAplicabilidadeDisponivel] = useState(false);
  const [consultarAplicabilidadesHabilitado, setConsultarAplicabilidadesHabilitado] = useState(false);
  const [tipoVisualizacaoPadraoConsulta, setTipoVisualizacaoPadraoConsulta] = useState<string>("Sistemista");
  const [projetistasConsultaOpcoes, setProjetistasConsultaOpcoes] = useState<FSelect[]>([]);
  const [projetistasConsultaSelecionados, setProjetistasConsultaSelecionados] = useState<FSelect[]>([]);
  const [empresasConsultaOpcoes, setEmpresasConsultaOpcoes] = useState<FSelect[]>([]);
  const [empresasConsultaSelecionadas, setEmpresasConsultaSelecionadas] = useState<FSelect[]>([]);
  const [projetistasCadastroOpcoes, setProjetistasCadastroOpcoes] = useState<FSelect[]>([]);
  const [projetistasCadastroSelecionados, setProjetistasCadastroSelecionados] = useState<FSelect[]>([]);

  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const [mappedIdReferencias, setMappedIdReferencias] =
    useState<Record<number, string>>();

  const [tiposReferencias, setTiposReferencias] = useState<FSelect[]>([]);

  const [referenciasBase, setReferenciasBase] = useState<FSelect[]>([]);
  const [referenciasAplicaveis, setReferenciasAplicaveis] = useState<FSelect[]>(
    []
  );
  const [referenciasProprias, setReferenciasProprias] = useState<FSelect[]>([]);

  const [selectedLiberacoes, setSelectedLiberacoes] = useState<Set<number>>(
    new Set()
  );
  const [selectedItemsRef, setSelectedItemsRef] = useState<number[]>([]);
  const [selectedItemsProj, setSelectedItemsProj] = useState<number[]>([]);

  const [selectedDashboards, setSelectedDashboards] = useState<Set<number>>(
    new Set()
  );

  const [accordionSelected, setAccordionSelected] = useState<number[]>([]);

  const [selectedTabela, setSelectedTabela] = useState<Set<number>>(new Set());

  async function getDadosEmpresas(idEmpresa: number) {
    try {
      const result = await getEmpresaById(idEmpresa);

      if (result) {
        const produtoNivelUmMaterialVMs =
          result.data.produtoNivelUmVM?.produtoNivelUmMaterialVMs;
        const newSelectedLiberacoes = new Set(selectedLiberacoes);

        produtoNivelUmMaterialVMs?.forEach((p) => {
          newSelectedLiberacoes.add(p.idTipoMaterial ?? 0);
        });
        setSelectedLiberacoes(newSelectedLiberacoes);

        //tabela
        const tabelaGetVMs = result.data.tabelaPrecoVMs;
        const newSelectedtabela = new Set(selectedTabela);

        tabelaGetVMs?.forEach((p) => {
          newSelectedtabela.add(p.idTipoMaterial ?? 0);
        });
        setSelectedTabela(newSelectedtabela);
        //tabela

        reset({
          referenciasAplicabilidadeVM: {
            idsReferenciasCodigoAplicavel:
              result.data.referenciasAplicabilidadeVM
                ?.idsReferenciasCodigoAplicavel,
            idsReferenciasCodigoBase:
              result.data.referenciasAplicabilidadeVM?.idsReferenciasCodigoBase,
            idsReferenciasCodigoProprio:
              result.data.referenciasAplicabilidadeVM
                ?.idsReferenciasCodigoProprio,
          },
          cepEmpresa: result.data.cep,
          complementoEmpresa: result.data.complemento,
          idCidadeEmpresa: result.data.idCidade ?? undefined,
          idEstadoEmpresa: result.data.idEstado ?? undefined,
          documentoEmpresa: result.data.cpfCnpj,
          enderecoEmpresa: result.data.endereco,
          nomeFantasiaEmpresa: result.data.nomeFantasia,
          numeroEmpresa: result.data.numero ?? undefined,
          idPerfilEmpresa: result.data.idPerfil,
          razaoSocialEmpresa: result.data.razaoSocial,
          ativoEmpresa: result.data.ativo,
          perfilEmpresa: result.data.idPerfil.toString(),
          tipoDashboardVMs: result.data.tipoDashboardVMs,
          produtoNivelUmVM: result.data.produtoNivelUmVM,
          aplicabilidadeDisponivel: result.data.aplicabilidadeDisponivel ?? false,
          tipoVisualizacaoPadraoConsulta: result.data.tipoVisualizacaoPadraoConsulta ?? "Sistemista",
          abasDoPerfilSelecionado:
            result?.data.abasUtilizadasPerfil.map((item) => ({
              value: item.id,
              label: item.nome,
            })) ?? [],
          abasParaAdicionar:
            result?.data.abasDisponiveisRecursosAdicionais.map((item) => ({
              value: item.id,
              label: item.nome,
            })) ?? [],
        });
        setCheckLiberacao(
          result.data.produtoNivelUmVM?.apenasConsulta || false
        );
        setCheckImportar(
          result.data.produtoNivelUmVM?.importarReferenciaMercado || false
        );
        setCheckExportar(
          result.data.produtoNivelUmVM?.exportarReferenciaMercado || false
        );
        
        setAplicabilidadeDisponivel(result.data.aplicabilidadeDisponivel || false);
        setConsultarAplicabilidadesHabilitado(result.data.consultarAplicabilidadesHabilitado || false);
        setTipoVisualizacaoPadraoConsulta(result.data.tipoVisualizacaoPadraoConsulta || "Sistemista");

        const idsProjetistasConsulta: number[] = (result.data as any).idsProjetistasConsulta ?? [];
        if (idsProjetistasConsulta.length > 0) {
          setProjetistasConsultaSelecionados(
            idsProjetistasConsulta
              .map((id) => projetistasConsultaOpcoes.find((p) => p.value === id))
              .filter(Boolean) as FSelect[]
          );
        }

        const idsEmpresasConsultaDisponiveis: number[] = (result.data as any).idsEmpresasConsultaDisponiveis ?? [];
        if (idsEmpresasConsultaDisponiveis.length > 0) {
          setEmpresasConsultaSelecionadas(
            idsEmpresasConsultaDisponiveis
              .map((id) => empresasConsultaOpcoes.find((e) => e.value === id))
              .filter(Boolean) as FSelect[]
          );
        }

        const idsProjetistasCadastro: number[] = (result.data as any).idsProjetistasCadastro ?? [];
        if (idsProjetistasCadastro.length > 0) {
          setProjetistasCadastroSelecionados(
            idsProjetistasCadastro
              .map((id) => projetistasCadastroOpcoes.find((p) => p.value === id))
              .filter(Boolean) as FSelect[]
          );
        }

        // TABELA
        const newTiposSelecionadosTabela = {
          ...formTabPreco.getValues("tipoSelecionados"),
        };
        tabelaGetVMs?.forEach((p) => {
          newTiposSelecionadosTabela[p.idTipoMaterial ?? 0] =
            p.idsReferencia?.map((ref) => {
              return {
                value: ref,
                label: mappedIdReferencias?.[ref] ?? "",
              };
            }) ?? [];
        });
        formTabPreco.setValue("tipoSelecionados", newTiposSelecionadosTabela);

        const newAccordionSelectedTabela: number[] = [];
        result.data?.tabelaPrecoVMs?.forEach((item) => {
          if (item) {
            newAccordionSelectedTabela.push(item?.idTipoMaterial);
          }
        });
        setAccordionSelected(newAccordionSelectedTabela);
        // TABELA

        formAplicabilidades.setValue(
          "selectReferenciasBase",
          result?.data.referenciasAplicabilidadeVM?.idsReferenciasCodigoBase?.map(
            (ref) => ({
              value: ref,
              label: mappedIdReferencias?.[ref] ?? "",
            })
          ) ?? []
        );

        formAplicabilidades.setValue(
          "selectReferenciasAplicaveis",
          result?.data.referenciasAplicabilidadeVM?.idsReferenciasCodigoAplicavel?.map(
            (ref) => ({
              value: ref,
              label: mappedIdReferencias?.[ref] ?? "",
            })
          ) ?? []
        );

        formAplicabilidades.setValue(
          "selectReferenciasProprias",
          result?.data.referenciasAplicabilidadeVM?.idsReferenciasCodigoProprio?.map(
            (ref) => ({
              value: ref,
              label: mappedIdReferencias?.[ref] ?? "",
            })
          ) ?? []
        );

        setTipoSelecionados((prev) => {
          const newTiposSelecionados = { ...prev };
          produtoNivelUmMaterialVMs?.forEach((p) => {
            newTiposSelecionados[p.idTipoMaterial ?? 0] =
              p.idsReferencia?.map((ref) => {
                return {
                  value: ref,
                  label: mappedIdReferencias?.[ref] ?? "",
                };
              }) ?? [];
          });
          return newTiposSelecionados;
        });
      }

      if (result && result.data) {
        const tipoMaterialVMs =
          result.data.produtoNivelUmVM?.produtoNivelUmMaterialVMs || [];

        const referenciaItems = tipoMaterialVMs.flatMap(
          (item) => item.idsReferencia || []
        );

        setSelectedItemsRef(referenciaItems);
      }
    } catch (error: any) {
      openNotification({
        isOpen: true,
        message: error?.message,
        type: "error",
      });
    }
  }

  const handleSubmitDadosCadastrais = async (data: DadosCadastraisForm) => {
    setIsLoadingSubmit(true);
    try {
      const produtoNivelUmMaterialVMs = Array.from(selectedLiberacoes).map(
        (idTipoMaterial) => {
          const nomesReferencia = tipoSelecionados[idTipoMaterial];
          const idsReferencia = nomesReferencia.map((item) => {
            return item.value;
          });

          return {
            idTipoMaterial,
            idsReferencia,
          };
        }
      );

      const tabelaVMs = Array.from(selectedTabela).map((idTipoMaterial) => {
        const nomesReferencia =
          formTabPreco.getValues("tipoSelecionados")[idTipoMaterial];
        const idsReferencia = nomesReferencia.map((item) => {
          return item.value;
        });

        return {
          idTipoMaterial,
          idsReferencia,
        };
      });

      const transformToEmpresa = (
        data: DadosCadastraisForm
      ): IPostEmpresasDadosCadastrais => {
        return {
          idEmpresa: params.id ? Number(params.id) : 0,
          nomeFantasia: data.nomeFantasiaEmpresa,
          cpfCnpj: data.documentoEmpresa,
          cep: data.cepEmpresa,
          ativo: data.ativoEmpresa ?? false,
          complemento: data?.complementoEmpresa ?? "",
          endereco: data.enderecoEmpresa,
          idCidade: data.idCidadeEmpresa ?? null,
          idEstado: data.idEstadoEmpresa ?? null,
          idPerfil: data.idPerfilEmpresa,
          numero: data.numeroEmpresa ?? null,
          razaoSocial: data.razaoSocialEmpresa,
          abas: selectedItems,
          produtoNivelUmVM: data.produtoNivelUmVM,
          tipoDashboardVMs: data.tipoDashboardVMs,
          tabelaPrecoVMs: tabelaVMs,
          referenciasAplicabilidadeVM: {
            idsReferenciasCodigoAplicavel: formAplicabilidades
              .getValues("selectReferenciasAplicaveis")
              .map((item) => item.value),
            idsReferenciasCodigoBase: formAplicabilidades
              .getValues("selectReferenciasBase")
              .map((item) => item.value),
            idsReferenciasCodigoProprio: formAplicabilidades
              .getValues("selectReferenciasProprias")
              .map((item) => item.value),
          },
          aplicabilidadeDisponivel: aplicabilidadeDisponivel,
          consultarAplicabilidadesHabilitado: consultarAplicabilidadesHabilitado,
          tipoVisualizacaoPadraoConsulta: tipoVisualizacaoPadraoConsulta,
          idsProjetistasConsulta: projetistasConsultaSelecionados.map((p) => p.value),
          idsProjetistasCadastro: projetistasCadastroSelecionados.map((p) => p.value),
          idsEmpresasConsultaDisponiveis: empresasConsultaSelecionadas.map((e) => e.value),
          dataUltimaAtualizacao: getBrasiliaTime(),
        };
      };

      const postData: IPostEmpresasDadosCadastrais = transformToEmpresa(data);

      if (params.id) {
        await postEmpresasDadosCadastrais(postData);
        openNotification({
          isOpen: true,
          message: "Empresa atualizada com sucesso!",
          type: "success",
        });
        formAplicabilidades.reset({
          selectReferenciasAplicaveis: formAplicabilidades.getValues(
            "selectReferenciasAplicaveis"
          ),
          selectReferenciasBase: formAplicabilidades.getValues(
            "selectReferenciasBase"
          ),
          selectReferenciasProprias: formAplicabilidades.getValues(
            "selectReferenciasProprias"
          ),
        });
        setHasChanges(false);
        return;
      }

      const result = await postEmpresasDadosCadastrais(postData);

      if (result) {
        openNotification({
          isOpen: true,
          message: "Empresa cadastrada com sucesso!",
          type: "success",
        });
      }
      formAplicabilidades.reset({
        selectReferenciasAplicaveis: formAplicabilidades.getValues(
          "selectReferenciasAplicaveis"
        ),
        selectReferenciasBase: formAplicabilidades.getValues(
          "selectReferenciasBase"
        ),
        selectReferenciasProprias: formAplicabilidades.getValues(
          "selectReferenciasProprias"
        ),
      });
      setHasChanges(false);
      setDataUltimaAtualizacao(new Date());
    } catch (error: any) {
      openNotification({
        isOpen: true,
        message: error?.message,
        type: "error",
      });
    } finally {
      setIsLoadingSubmit(false);
    }
  };

  const fecthListarPorTiposMaterias = async () => {
    try {
      const result = await getListarPorTipoMaterial();

      if (result) {
        setMappedIdReferencias((prev) => {
          const newMappedRefs = { ...prev };
          result.forEach((ref) => (newMappedRefs[ref.value] = ref.label));
          return newMappedRefs;
        });
        setTiposReferencias(result);
        setReferenciasBase(result);
        setReferenciasAplicaveis(result);
        setReferenciasProprias(result);
      }
    } catch (error: any) {
      openNotification({
        isOpen: true,
        message: "Erro ao listar por tipos de materiais.",
        type: "error",
      });
    }
  };

  const [shouldGetEmpresa, setShouldGetEmpresa] = useState(false);

  useEffect(() => {
    const loadAll = async () => {
      await Promise.all([
        fecthListarPorTiposMaterias(),
        fetchProjetistasConsulta(),
        fetchEmpresasConsulta(),
      ]);
      setShouldGetEmpresa(true);
    };
    loadAll();
  }, []);

  useEffect(() => {
    shouldGetEmpresa && params.id && getDadosEmpresas(Number(params.id));
  }, [params.id, shouldGetEmpresa]);

  const fetchProjetistasConsulta = async () => {
    try {
      const projetistas = await listarProjetistas();
      const opcoes = projetistas.map((p) => ({ value: p.value, label: p.label }));
      setProjetistasConsultaOpcoes(opcoes);
      setProjetistasCadastroOpcoes(opcoes);
    } catch {
      setProjetistasConsultaOpcoes([]);
      setProjetistasCadastroOpcoes([]);
    }
  };

  const fetchEmpresasConsulta = async () => {
    try {
      const empresas = await listarEmpresasConsulta();
      setEmpresasConsultaOpcoes(
        empresas.map((e) => ({ value: e.idEmpresa, label: e.nomeFantasia }))
      );
    } catch {
      setEmpresasConsultaOpcoes([]);
    }
  };

  return (
    <PreventExit
      handleIsOpenModalUnsaved={handleIsOpenModalUnsaved}
      handleLinkNavigateBlocked={handleLinkNavigateBlocked}
      isOpenModalUnsaved={isOpenModalUnsaved}
      handleOnCloseModalUnsavedEdit={handleOnCloseModalUnsavedEdit}
      linkNavigateBlocked={linkNavigateBlocked}
      isGoBack={isGoBack}
    >
      <FormProvider
        {...{
          control,
          handleSubmit,
          reset,
          setValue,
          watch,
          setError,
          getValues,
          clearErrors,
          formState,
          ...methods,
        }}
      >
        <Grid container p={1.5}>
          <Grid md={12}>
            {tiposReferencias.length === 0 ? (
              <Grid
                sx={{
                  minHeight: "60vh",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <DataNotFound visible />
              </Grid>
            ) : (
              <>
                {/* Seção: Cadastrar/Editar aplicabilidades */}
                <Accordion defaultExpanded sx={{ mb: 3 }}>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center", pr: 2 }}>
                      <Typography sx={{ fontSize: fontsSizes.mlarge, fontWeight: "bold", color: "#3C90AD" }}>
                        Cadastrar/Editar aplicabilidades
                      </Typography>
                      <Switch
                        checked={aplicabilidadeDisponivel}
                        onChange={(e) => {
                          setAplicabilidadeDisponivel(e.target.checked);
                          setValue("aplicabilidadeDisponivel", e.target.checked, { shouldDirty: true });
                          setHasChanges(true);
                        }}
                        color="primary"
                        onClick={(e) => e.stopPropagation()}
                        onFocus={(e) => e.stopPropagation()}
                      />
                    </Box>
                  </AccordionSummary>
                  {aplicabilidadeDisponivel && (
                    <AccordionDetails>
                      <Grid container spacing={3}>
                        <Grid item md={12}>
                          <FormControl sx={{ m: 1, width: "100%" }}>
                            <Typography
                              sx={{
                                color: "secondary",
                                fontSize: fontsSizes.medium,
                              }}
                            >
                              Referências dos Códigos Base:
                            </Typography>
                        <Select
                          isClearable={false}
                          isMulti
                          maxMenuHeight={290}
                          menuPosition="fixed"
                          options={referenciasBase}
                          value={formAplicabilidades.watch(
                            "selectReferenciasBase"
                          )}
                          onChange={(selectedOptions) => {
                            formAplicabilidades.setValue(
                              "selectReferenciasBase",
                              selectedOptions as FSelect[],
                              { shouldDirty: true }
                            );
                          }}
                          placeholder="Selecione o Código Base"
                          styles={{
                            control: (base) => ({
                              ...base,
                              backgroundColor: "#EDEDED",
                              borderRadius: "4px",
                            }),
                            multiValue: (base) => ({
                              ...base,
                              backgroundColor: "#3C90AD",
                              borderRadius: "16px",
                              paddingLeft: "4px",
                            }),
                            multiValueLabel: (base) => ({
                              ...base,
                              color: "#fff",
                              fontWeight: 500,
                              paddingRight: "6px",
                            }),
                            multiValueRemove: (base) => ({
                              ...base,
                              color: "#1a5a6e",
                              borderRadius: "0 16px 16px 0",
                              ":hover": {
                                backgroundColor: "#337991",
                                color: "#1a5a6e",
                              },
                            }),
                          }}
                        />
                      </FormControl>
                    </Grid>
                    <Grid item md={12}>
                      <FormControl sx={{ m: 1, width: "100%" }}>
                        <Typography
                          sx={{
                            color: "secondary",
                            fontSize: fontsSizes.medium,
                          }}
                        >
                          Referências dos Códigos Aplicáveis:
                        </Typography>
                        <Select
                          isClearable={false}
                          isMulti
                          maxMenuHeight={290}
                          menuPosition="fixed"
                          options={referenciasAplicaveis}
                          value={formAplicabilidades.watch(
                            "selectReferenciasAplicaveis"
                          )}
                          onChange={(selectedOptions) => {
                            formAplicabilidades.setValue(
                              "selectReferenciasAplicaveis",
                              selectedOptions as FSelect[],
                              { shouldDirty: true }
                            );
                          }}
                          placeholder="Selecione o Código Aplicável"
                          styles={{
                            control: (base) => ({
                              ...base,
                              backgroundColor: "#EDEDED",
                              borderRadius: "4px",
                            }),
                            multiValue: (base) => ({
                              ...base,
                              backgroundColor: "#3C90AD",
                              borderRadius: "16px",
                              paddingLeft: "4px",
                            }),
                            multiValueLabel: (base) => ({
                              ...base,
                              color: "#fff",
                              fontWeight: 500,
                              paddingRight: "6px",
                            }),
                            multiValueRemove: (base) => ({
                              ...base,
                              color: "#1a5a6e",
                              borderRadius: "0 16px 16px 0",
                              ":hover": {
                                backgroundColor: "#337991",
                                color: "#1a5a6e",
                              },
                            }),
                          }}
                        />
                      </FormControl>
                    </Grid>
                    <Grid item md={12}>
                      <FormControl sx={{ m: 1, width: "100%" }}>
                        <Typography
                          sx={{
                            color: "secondary",
                            fontSize: fontsSizes.medium,
                          }}
                        >
                          Selecione o projetista para filtro no cadastro de aplicabilidades:
                        </Typography>
                        <Select
                          isClearable={false}
                          isMulti
                          maxMenuHeight={290}
                          menuPosition="fixed"
                          options={projetistasCadastroOpcoes}
                          value={projetistasCadastroSelecionados}
                          onChange={(selectedOptions) => {
                            setProjetistasCadastroSelecionados(selectedOptions as FSelect[]);
                            setHasChanges(true);
                          }}
                          placeholder="Selecione os projetistas"
                          styles={{
                            control: (base) => ({
                              ...base,
                              backgroundColor: "#EDEDED",
                              borderRadius: "4px",
                            }),
                            multiValue: (base) => ({
                              ...base,
                              backgroundColor: "#3C90AD",
                              borderRadius: "16px",
                              paddingLeft: "4px",
                            }),
                            multiValueLabel: (base) => ({
                              ...base,
                              color: "#fff",
                              fontWeight: 500,
                              paddingRight: "6px",
                            }),
                            multiValueRemove: (base) => ({
                              ...base,
                              color: "#1a5a6e",
                              borderRadius: "0 16px 16px 0",
                              ":hover": {
                                backgroundColor: "#337991",
                                color: "#1a5a6e",
                              },
                            }),
                          }}
                        />
                      </FormControl>
                    </Grid>
                      </Grid>
                    </AccordionDetails>
                  )}
                </Accordion>

                {/* Seção: Consultar aplicabilidades */}
                <Accordion defaultExpanded sx={{ mb: 3 }}>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center", pr: 2 }}>
                      <Typography sx={{ fontSize: fontsSizes.mlarge, fontWeight: "bold", color: "#3C90AD" }}>
                        Consultar aplicabilidades
                      </Typography>
                      <Switch
                        checked={consultarAplicabilidadesHabilitado}
                        onChange={(e) => {
                          setConsultarAplicabilidadesHabilitado(e.target.checked);
                          setHasChanges(true);
                        }}
                        color="primary"
                        onClick={(e) => e.stopPropagation()}
                        onFocus={(e) => e.stopPropagation()}
                      />
                    </Box>
                  </AccordionSummary>
                  {consultarAplicabilidadesHabilitado && (
                    <AccordionDetails>
                      <Grid container spacing={3}>
                        <Grid item md={12}>
                          <FormControl sx={{ m: 1, width: "100%" }}>
                            <Typography
                              sx={{
                                color: "secondary",
                                fontSize: fontsSizes.medium,
                              }}
                            >
                              Tipo de consulta das aplicabilidades:
                            </Typography>
                            <Select
                              isClearable={false}
                              maxMenuHeight={290}
                              menuPosition="fixed"
                              options={[
                                { value: "Sistemista", label: "Sistemista" },
                                { value: "Fornecedor", label: "Fornecedor de Componentes" },
                              ]}
                              value={
                                tipoVisualizacaoPadraoConsulta
                                  ? { value: tipoVisualizacaoPadraoConsulta, label: tipoVisualizacaoPadraoConsulta === "Sistemista" ? "Sistemista" : "Fornecedor de Componentes" }
                                  : null
                              }
                              onChange={(selectedOption) => {
                                if (selectedOption) {
                                  setTipoVisualizacaoPadraoConsulta(selectedOption.value);
                                  setValue("tipoVisualizacaoPadraoConsulta", selectedOption.value, { shouldDirty: true });
                                  setHasChanges(true);
                                }
                              }}
                              placeholder="Selecione o tipo de consulta"
                              styles={{
                                control: (base) => ({
                                  ...base,
                                  backgroundColor: "#EDEDED",
                                  borderRadius: "4px",
                                }),
                              }}
                            />
                          </FormControl>
                        </Grid>
                        <Grid item md={12}>
                          <FormControl sx={{ m: 1, width: "100%" }}>
                            <Typography
                              sx={{
                                color: "secondary",
                                fontSize: fontsSizes.medium,
                              }}
                            >
                              Selecione a aplicabilidade de qual empresa estará disponível para consulta:
                            </Typography>
                            <Select
                              isClearable={false}
                              isMulti
                              maxMenuHeight={290}
                              menuPosition="fixed"
                              options={empresasConsultaOpcoes}
                              value={empresasConsultaSelecionadas}
                              onChange={(selectedOptions) => {
                                setEmpresasConsultaSelecionadas(selectedOptions as FSelect[]);
                                setHasChanges(true);
                              }}
                              placeholder="Selecione as empresas"
                              styles={{
                                control: (base) => ({
                                  ...base,
                                  backgroundColor: "#EDEDED",
                                  borderRadius: "4px",
                                }),
                                multiValue: (base) => ({
                                  ...base,
                                  backgroundColor: "#3C90AD",
                                  borderRadius: "16px",
                                  paddingLeft: "4px",
                                }),
                                multiValueLabel: (base) => ({
                                  ...base,
                                  color: "#fff",
                                  fontWeight: 500,
                                  paddingRight: "6px",
                                }),
                                multiValueRemove: (base) => ({
                                  ...base,
                                  color: "#1a5a6e",
                                  borderRadius: "0 16px 16px 0",
                                  ":hover": {
                                    backgroundColor: "#337991",
                                    color: "#1a5a6e",
                                  },
                                }),
                              }}
                            />
                          </FormControl>
                        </Grid>
                        <Grid item md={12}>
                          <FormControl sx={{ m: 1, width: "100%" }}>
                            <Typography
                              sx={{
                                color: "secondary",
                                fontSize: fontsSizes.medium,
                              }}
                            >
                              Selecione o projetista para consulta das aplicabilidades:
                            </Typography>
                            <Select
                              isClearable={false}
                              isMulti
                              maxMenuHeight={290}
                              menuPosition="fixed"
                              options={projetistasConsultaOpcoes}
                              value={projetistasConsultaSelecionados}
                              onChange={(selectedOptions) => {
                                setProjetistasConsultaSelecionados(selectedOptions as FSelect[]);
                                setHasChanges(true);
                              }}
                              placeholder="Selecione os projetistas"
                              styles={{
                                control: (base) => ({
                                  ...base,
                                  backgroundColor: "#EDEDED",
                                  borderRadius: "4px",
                                }),
                                multiValue: (base) => ({
                                  ...base,
                                  backgroundColor: "#3C90AD",
                                  borderRadius: "16px",
                                  paddingLeft: "4px",
                                }),
                                multiValueLabel: (base) => ({
                                  ...base,
                                  color: "#fff",
                                  fontWeight: 500,
                                  paddingRight: "6px",
                                }),
                                multiValueRemove: (base) => ({
                                  ...base,
                                  color: "#1a5a6e",
                                  borderRadius: "0 16px 16px 0",
                                  ":hover": {
                                    backgroundColor: "#337991",
                                    color: "#1a5a6e",
                                  },
                                }),
                              }}
                            />
                          </FormControl>
                        </Grid>
                      </Grid>
                    </AccordionDetails>
                  )}
                </Accordion>
              </>
            )}
          </Grid>
          {tiposReferencias.length === 0 ? (
            <Grid></Grid>
          ) : (
            <Grid item md={12}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginTop: 2,
                }}
              >
                <LoadingButton
                  type="submit"
                  variant="contained"
                  endIcon={<Save />}
                  onClick={handleSubmit(handleSubmitDadosCadastrais)}
                  loading={isLoadingSubmit}
                  disabled={!formStateAplicabilidades.isDirty && !hasChanges}
                  sx={{
                    marginLeft: 1,
                  }}
                >
                  Salvar
                </LoadingButton>
              </Box>
            </Grid>
          )}
        </Grid>
      </FormProvider>
    </PreventExit>
  );
};
